module.exports = __webpack_public_path__ + "static/Symphonia5-3ce316e69fc21401cda83be8e04c5480.png";